/*
  © 2025 FalconTheme
  https://www.falcontheme.com
*/

class ProductForm extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector("form");
    this.button = this.form.querySelector('button[name="add"]');
    this.form.addEventListener("submit", (event) => this.onSubmit(event));
  }
}
customElements.define("product-form", ProductForm);
